<slick-dialog key="DIALOG_CUSTOMER_EDIT" header="Customer" height="1000" width="1200" #dialogRef>
	<div *ngIf="customerModel">
		<customer-edit #customerEditRef [customerModel]="customerModel" [isDialog]="true" [openInSummary]="showSummary" (editingCustomerChanged)="isEditing = $event"></customer-edit>
	</div>
	<slick-dialog-footer>
		<div class="d-flex ">
			<ng-container *ngIf="isEditing">
				<button class="save-button btn btn-outline-success save-button me-3" (click)="onSave()" [slick-button-spinner]="spinnerStatus">
					<i class="bi bi-check-circle"></i> Save
				</button>
				<button class="cancel-button btn btn-outline-danger save-button" (click)="onCancel()">
					<i class="bi bi-x-circle"></i> Cancel
				</button>
			</ng-container>
			<button *ngIf="!isEditing" class="cancel-button btn btn-outline-secondary save-button" (click)="onCancel()">
				<i class="bi bi-x-circle"></i> Close
			</button>
			<div class="ms-auto">
				<div *ngIf="!skeditPay">
					<div *ngIf="customerModel?.acceptedTerms === true" class="d-flex">
						<button class="me-2 btn btn-outline-danger" (click)="resetCustomerSignedStatus()"><i class="bi bi-reset"></i>&nbsp;<b>Reset Signed Status</b></button>
						<div class="pt-2 mt-2"><i class="bi bi-check-circle-fill text-success"></i>&nbsp;<b>Service Agreement Signed</b></div>
					</div>
					<div *ngIf="customerModel?.acceptedTerms === false">
						<button type="button" style="width: 280px;" class="btn btn-outline-primary" [slick-button-spinner]="agreementspinnerStatus" (click)="sendServiceAgreement()">
							<i class="bi bi-envelope"></i> Send Service Agreement
						</button>
					</div>
				</div>
			</div>
		</div>

	</slick-dialog-footer>
</slick-dialog>